import { keccak256, toHex, type Address } from 'viem';
import { base, baseSepolia } from 'wagmi/chains';
import ESCROW_ABI_JSON from './escrow-abi.json';

export const ESCROW_ABI = ESCROW_ABI_JSON;

export const ESCROW_CONTRACT_ADDRESS = (import.meta.env.VITE_ESCROW_CONTRACT_ADDRESS ?? '') as Address;

export const ESCROW_CHAIN_ID = Number(import.meta.env.VITE_CHAIN_ID ?? baseSepolia.id) as typeof base.id | typeof baseSepolia.id;

export const USDC_ADDRESSES: Record<number, Address> = {
  [base.id]: '0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913',
  [baseSepolia.id]: '0x036CbD53842c5426634e7929541eC2318f3dCF7e',
};

export const ERC20_ABI = [
  {
    inputs: [
      { name: 'spender', type: 'address' },
      { name: 'amount', type: 'uint256' },
    ],
    name: 'approve',
    outputs: [{ name: '', type: 'bool' }],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { name: 'owner', type: 'address' },
      { name: 'spender', type: 'address' },
    ],
    name: 'allowance',
    outputs: [{ name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ name: 'account', type: 'address' }],
    name: 'balanceOf',
    outputs: [{ name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'decimals',
    outputs: [{ name: '', type: 'uint8' }],
    stateMutability: 'view',
    type: 'function',
  },
] as const;

/**
 * Compute the on-chain escrow wager ID from the database wager ID.
 * The contract uses bytes32 = keccak256(databaseId).
 */
export function computeEscrowWagerId(dbId: string): `0x${string}` {
  return keccak256(toHex(dbId));
}
